/**
 * SessionsList component
 * Renders the start/resume affordance (slot) followed by the Completed Sessions list.
 *
 * The student's active session is surfaced ONCE — by the ResumeSessionHero in the
 * startSessionButton slot ("You have an open session"). A separate "Active Sessions"
 * list was removed because it duplicated the resume hero (BUG: duplicate active card).
 */

import { SessionCard } from '@/components/SessionCard';
import { EmptyState } from '@/components/EmptyState';
import type { Session } from '@/types/session';

export interface SessionsListProps {
  /** Completed sessions to display */
  completedSessions: Session[];

  /**
   * Slot for the start/continue session affordance, rendered at the top.
   * The active session is shown here via ResumeSessionHero (no separate active list).
   */
  startSessionButton?: React.ReactNode;
}

/**
 * SessionsList - Start/resume slot + Completed Sessions section
 */
export function SessionsList({ completedSessions, startSessionButton }: SessionsListProps) {
  return (
    <div className="space-y-6 md:space-y-8">
      {/* Start / resume slot — the primary action (and the single active-session affordance). */}
      {startSessionButton}

      {/* Completed Sessions Section */}
      <section>
        <h2 className="mb-3 font-display text-lg font-semibold text-otter-earth-800">
          Completed Sessions
        </h2>
        <div className="space-y-2.5">
          {completedSessions.length > 0 ? (
            completedSessions.map((session) => (
              <SessionCard key={session.sessionId} session={session} />
            ))
          ) : (
            <EmptyState message="No completed sessions yet" />
          )}
        </div>
      </section>
    </div>
  );
}
